import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormService } from '../service';
import { CartService } from '../../../../../../../services/cart.service';
import { CommonModule, DatePipe } from '@angular/common';
import { ParkingCardComponent } from '../../../../../../components/parking-card/parking-card.component';
import { CdkStepper } from '@angular/cdk/stepper';
import { Router } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { ParkingShuttleFlightInfoComponent } from '../../../../../../components/parkingshuttleflight-info/parkingshuttleflight-info.component';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { BookingConfigService } from '../../../../../../services/booking-config.service';
import { TopNavbarComponent } from '../../../../../components/top-navbar/top-navbar.component';
import { timeout, catchError } from 'rxjs/operators';
import { throwError, of } from 'rxjs';

@Component({
  selector: 'app-parking',
  imports: [
    ParkingCardComponent,
    CommonModule,
    TranslocoModule,
    ParkingShuttleFlightInfoComponent,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    TopNavbarComponent
  ],
  providers: [DatePipe, CdkStepper],
  templateUrl: './parking.component.html',
  styleUrl: './parking.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    'style': 'font-family: Inter, sans-serif;'
  }
})

export class ParkingComponent implements OnInit {
  @Output() parkingPickedEvent = new EventEmitter();
  parkings: any = [];
  loading = false;
  loaded = false;
  parkingGroup: any;
  hotels: any;
  departureInfo: any;
  arrivalInfo: any;
  parkingDays: number = 1;
  discountCodeControl: FormControl = new FormControl('', { validators: Validators.nullValidator });
  isDiscountCodeWrong: boolean = false;
  tentantConfigSortingParking: any = {
    'skavsta': (parkings: any[]) => {
      []
      if (parkings.length > 1) {
        const firstItem = parkings.shift();
        parkings.push(firstItem);
      }
      return parkings;
    }
  };
  site: any;
  timeoutError: boolean = false;
  showSubscription: boolean = sessionStorage.getItem('showSubscription') === 'true' || false;
  isParkingPermitUser: boolean = sessionStorage.getItem('isParkingPermitUser') === 'true' || false;
  isQuality2daysBooking: boolean = sessionStorage.getItem('isQuality2daysBooking') === 'true' || false;
  orgId: any = null;
  isAiden2daysBooking: boolean = sessionStorage.getItem('isAiden2daysBooking') === 'true' || false;

  constructor(
    private _formService: FormService,
    private cartService: CartService,
    private datepipe: DatePipe,
    private router: Router,
    private bookingConfigService: BookingConfigService
  ) {
    const config = this.bookingConfigService.getConfig();
    this.site = config.site;
    this.orgId = config.orgId;

    if (this.site === 'nazar') {
      this.discountCodeControl.setValue('nazar');
      this.discountCodeControl.disable();
    }

    if (this.site === 'tui') {
      this.discountCodeControl.setValue('TUI10');
      this.discountCodeControl.disable();
    }
  }

  ngOnInit(): void {
    const code = this._formService.discountCode;
    if (code && (code.toUpperCase() === 'NONE' || code === 'null')) {
      this.discountCodeControl.setValue('');
    } else {
      this.discountCodeControl.setValue(code || '');
    }
    this.searchForBookings();
    this.parkingGroup = this._formService.getForm().get('parkingGroup');
    this.hotels = this._formService.getForm().get('hotels');

    this.setDepartureArrivalInfo();

    this.parkingGroup.valueChanges.subscribe((value: any) => {
      this.setDepartureArrivalInfo();
    });

    this.discountCodeControl.valueChanges.subscribe((value: string) => {
      if (this.site === 'quality-xpo-arlanda' && value?.toLowerCase().trim() === 'resa') {
        this.isDiscountCodeWrong = true;
      } else {
        this.isDiscountCodeWrong = false;
      }
    });
  }

  isPreSelectedParking(item: any): boolean {
    if (!item) return false;

    const isFromCustomerHome = sessionStorage.getItem('isFromCustomerHome') === 'true';
    if (!isFromCustomerHome) {
      return false;
    }

    let pre: any = null;
    const saved = sessionStorage.getItem('selectedParkingFromSearch');
    if (saved) {
      try {
        pre = JSON.parse(saved);
      } catch (e) { }
    }
    if (!pre) {
      pre = this._formService.selectedParking || history.state?.selectedParking;
    }
    if (!pre) return false;

    // 1. Check productId
    const itemProductId = (item.productId || '').toString().toLowerCase();
    const preProductId = (pre.productId || '').toString().toLowerCase();
    if (itemProductId && preProductId && itemProductId === preProductId) {
      return true;
    }

    // 2. Check productCode
    const itemCode = (item.productCode || '').toString().toLowerCase();
    const preCode = (pre.productCode || '').toString().toLowerCase();
    if (itemCode && preCode && itemCode === preCode) {
      return true;
    }

    // 3. Check name
    const itemName = (item.name || item.description || item.parkingName || '').toString().toLowerCase();
    const preName = (pre.name || pre.description || pre.parkingName || '').toString().toLowerCase();
    if (itemName && preName && itemName === preName) {
      return true;
    }

    // 4. Fallback to id only if productId/productCode are not present (non-subscription parkings)
    if (!item.productId && !pre.productId && !item.productCode && !pre.productCode) {
      const itemId = (item.id || item.parkingId || '').toString().toLowerCase();
      const preId = (pre.id || pre.parkingId || '').toString().toLowerCase();
      if (itemId && preId && itemId === preId) {
        return true;
      }
    }

    return false;
  }

  public get isSearchEnabled(): boolean {
    if (
      this._formService.searchStartDate instanceof Date &&
      this._formService.searchEndDate instanceof Date &&
      this._formService.searchStartDate <= this._formService.searchEndDate &&
      this.validateFlights()
    ) {
      return true;
    }
    return false;
  }

  validateFlights() {
    if (this._formService.selectedArrivalFlight || this._formService.selectedDepartureFlight.getValue()) {
      if (!this._formService.selectedArrivalFlight || !this._formService.selectedDepartureFlight.getValue()) {
        return false;
      }
    }
    return true;
  }

  getAvailableParkingsForOrganization(periodFrom: string, periodTo: string, discountCode: string) {
    let orgId = this.orgId;

    if (this.isParkingPermitUser == true) {
      orgId = '4FF1E3D8-950F-4E11-AB60-0F0769FF23A2';
    }

    if (this.site?.toLocaleLowerCase() == 'tui') {
      orgId = '2868EF69-054C-40BD-93AE-85CF08E4C71F';
    }

    if (this.site?.toLocaleLowerCase() == 'nazar') {
      orgId = '3868EF69-054C-40BD-93AE-85CF08E4C71F';
    }

    this.cartService
      .getAvailableParkings(orgId, periodFrom, periodTo, discountCode)
      .pipe(
        timeout(30000),
        catchError(error => {
          if (error.name === 'TimeoutError') {
            console.error('API call timed out after 30 seconds');
            this.loading = false;
            this.timeoutError = true;
            return of(null);
          }
          return throwError(() => error);
        })
      )
      .subscribe(parkings => {
        if (this.site?.toLocaleLowerCase() == 'tui' || this.site?.toLocaleLowerCase() == 'nazar') {
          this.parkings = parkings?.parkings.filter((parking: any) => {
            return parking.id == '8c98315a-b2ad-4e70-86f9-5d54992fed26';
          })
        } else {
          this.parkings = parkings?.parkings?.reverse();
        }

        if (this.showSubscription || this.isParkingPermitUser) {
          this.parkings = this.parkings.filter((parking: any) => parking.subscriptionParking == true);
        } else {
          this.parkings = this.parkings.filter((parking: any) => parking.subscriptionParking == false);
        }

        this.parkings = this.parkings.map((parking: any) => {
          const parseFeature = (feature: string) => {
            if (!feature) return feature;
            if (typeof feature !== 'string') return feature;

            try {
              let decoded = feature.replace(/&quot;/g, '"');
              decoded = decoded.replace(/\\u0022/g, '"');
              return decoded.startsWith('{') ? JSON.parse(decoded) : decoded;
            } catch {
              return feature;
            }
          };

          parking.features = [
            parseFeature(parking.feature1),
            parseFeature(parking.feature2),
            parseFeature(parking.feature3),
            parseFeature(parking.feature4),
            parseFeature(parking.feature5),
            parseFeature(parking.feature6),
          ];
          return parking;
        });

        if (discountCode != 'NONE') {
          this.isDiscountCodeWrong = !this.parkings.some((parking: any) => parking.discountCheckAmount > 0 || parking.discountCheckPercent > 0);
        }

        if (this.tentantConfigSortingParking[this.site]) {
          this.parkings = this.tentantConfigSortingParking[this.site](this.parkings);
        }

        this._formService.availableParkings = this.parkings;
        this.loading = false;
        this.loaded = true;
      });
  }

  applyDiscountCode() {
    this.isDiscountCodeWrong = false;
    if (this.site === 'quality-xpo-arlanda' && this.discountCodeControl.value?.toLowerCase() === 'resa') {
      this.isDiscountCodeWrong = true;
      return;
    }
    this.searchForBookings();
  }

  setDepartureArrivalInfo() {
    this.departureInfo = {
      date: this.parkingGroup.value.departureDate ? this.parkingGroup.value.departureDate : '',
      flightId: this.parkingGroup.value.departureFlight?.flightId ? this.parkingGroup.value.departureFlight?.flightId : '',
      location: this.parkingGroup.value.departureFlight ? this.parkingGroup.value.departureFlight.arrivalAirportSwedish : '',
      transferLocation: this.hotels?.value.departureHotel ? this.hotels?.value.departureHotel.viewValue
        : this.parkingGroup.value.departureFlight ? this.parkingGroup.value.departureFlight.locationAndStatus.terminal
          : '',
      hotel: this.hotels?.value.departureHotel ? true : false,
      flightDate: this.parkingGroup.value.departureFlight ? this.parkingGroup.value.departureFlight.departureTime.scheduled : '',
    }
    this.arrivalInfo = {
      date: this.parkingGroup.value.arrivalDate ? this.parkingGroup.value.arrivalDate : '',
      flightId: this.parkingGroup.value.arrivalFlight ? this.parkingGroup.value.arrivalFlight.flightId : '',
      location: this.parkingGroup.value.arrivalFlight ? this.parkingGroup.value.arrivalFlight.departureAirportSwedish : '',
      transferLocation: this.hotels?.value.arrivalHotel ? this.hotels?.value.arrivalHotel.viewValue
        : this.parkingGroup.value.arrivalFlight ? this.parkingGroup.value.arrivalFlight.locationAndStatus.terminal
          : '',
      hotel: this.hotels?.value.arrivalHotel ? true : false,
      flightDate: this.parkingGroup.value.arrivalFlight ? this.parkingGroup.value.arrivalFlight.arrivalTime.scheduled : '',
    }

    if (this.site == 'quality' || this.site == 'aiden') {
      const searchForm = this._formService.getForm().get('search');
      if (searchForm?.value?.isArrivalHotel) {
        this.arrivalInfo.hotel = true;
      } else {
        this.arrivalInfo.hotel = false;
      }

      if (this._formService.isArrivalByFlight) {
        this.arrivalInfo.transferLocation = this.parkingGroup.value?.arrivalFlight?.locationAndStatus.terminal;
        this.arrivalInfo.transferDateTime = this._formService.arrivalPickup;
      }
      else {
        const arrTerminal = this._formService.arrivalTerminal;
        this.arrivalInfo.transferLocation = arrTerminal?.terminalCode;
        this.arrivalInfo.transferDateTime = this._formService.arrivalPickup;
        this.arrivalInfo.flightId = '';
      }

      if (this._formService.isDepartureHotel) {
        const depTerminal = this._formService.departureTerminal;
        this.departureInfo.transferLocation = depTerminal?.terminalCode;
        this.departureInfo.transferDateTime = this._formService.departurePickup;
        this.departureInfo.hotel = true;
        this.departureInfo.flightId = '';
      } else {
        this.departureInfo.transferLocation = this.parkingGroup.value?.departureFlight?.locationAndStatus.terminal;
        this.departureInfo.transferDateTime = this._formService.departurePickup;
      }
    }
  }

  searchForBookings(): void {
    this._formService.getForm().get('parkingGroup').controls['departureDate'].setValue(this._formService.searchStartDate);
    this._formService.getForm().get('parkingGroup').controls['arrivalDate'].setValue(this._formService.searchEndDate);
    this._formService.getForm().get('parkingGroup').controls.arrivalFlight.setValue(this._formService.selectedArrivalFlight);
    this._formService.getForm().get('parkingGroup').controls.departureFlight.setValue(this._formService.selectedDepartureFlight.getValue());
    this._formService.updatedDepartureFlight = this._formService.selectedDepartureFlight.getValue();

    let periodFrom: string | null = this.datepipe.transform(this._formService.searchStartDate, 'yyyy-MM-ddTHH:mm:ss');
    let periodTo: string | null = this.datepipe.transform(this._formService.searchEndDate, 'yyyy-MM-ddTHH:mm:ss');
    this.loaded = false;
    this.loading = true;

    this.parkingDays = this._formService.calculateParkingDays(this._formService.searchStartDate, this._formService.searchEndDate);
    let rawDiscount = (this.discountCodeControl.getRawValue() || '').trim();
    if (rawDiscount.toUpperCase() === 'NONE' || rawDiscount === 'null') {
      rawDiscount = '';
    }
    this._formService.discountCode = rawDiscount;
    const apiDiscountCode = rawDiscount.length ? rawDiscount : 'NONE';
    this.getAvailableParkingsForOrganization(periodFrom!, periodTo!, apiDiscountCode);
  }

  pickParking(parking: any): void {
    if (parking.subscriptionParking == true) {
      const startDate = new Date(parking.subscriptionParkingStartDate);
      const endDate = new Date(parking.subscriptionParkingEndDate);

      this._formService.searchStartDate = startDate;
      this._formService.searchEndDate = endDate;

      this._formService.getForm().get('parkingGroup').controls['departureDate'].setValue(startDate);
      this._formService.getForm().get('parkingGroup').controls['arrivalDate'].setValue(endDate);

      parking.dailyPrice = parking.totalPrice / (parking.subscriptionParkingDays);
      this._formService.selectedParking = parking;
      this._formService.getForm().get('parking').controls.selectedParking.setValue(parking);
      this.parkingPickedEvent.emit(parking);
    } else {
      let daysBetween = this._formService.daysBetweenDates(
        this._formService.getForm().get('parkingGroup').controls['departureDate'].value,
        this._formService.getForm().get('parkingGroup').controls['arrivalDate'].value
      )
      parking.dailyPrice = parking.totalPrice / (daysBetween === 0 ? 1 : daysBetween);
      this._formService.selectedParking = parking;
      this._formService.getForm().get('parking').controls.selectedParking.setValue(parking);
      this.parkingPickedEvent.emit(parking);
    }
  }

  goBack() {
    const config = this.bookingConfigService.getConfig();

    if (config?.searchSelect == 'advanced') {
      const hotels = this._formService.getForm().get('hotels');
      const flights = this._formService.getForm().get('flights');
      const search = this._formService.getForm().get('search');
      let previousSearchData = {
        flightDepartureDate: search.controls.departureFlightDate?.value,
        flightArrivalDate: search.controls.arrivalFlightDate?.value,
        arrivalDatetime: search.controls.arrivalDatetime?.value,
        departureDatetime: search.controls.departureDatetime?.value,
        hotelArrivalDate: hotels.controls.arrivalDatetime?.value,
        hotelDepartureDate: hotels.controls.departureDatetime?.value,
        arrivalHotel: hotels.controls.arrivalHotel?.value,
        departureHotel: hotels.controls.departureHotel?.value,
        departureFlight: flights.controls.departureFlight?.value,
        arrivalFlight: flights.controls.arrivalFlight?.value,
        discountCode: this._formService.discountCode
      }
      this.router.navigate(['parkifly', this.site], { state: previousSearchData });
    } else if (config.searchSelect == 'simple') {
      const parkingGroup = this._formService.getForm().get('parkingGroup');
      let previousSearchData = {
        departureDate: parkingGroup.controls.departureDate?.value,
        arrivalDate: parkingGroup.controls.arrivalDate?.value,
        discountCode: this._formService.discountCode
      }
      const isParkingPermitUser = sessionStorage.getItem('isParkingPermitUser') === 'true';
      const isQuality2daysBooking = sessionStorage.getItem('isQuality2daysBooking') === 'true';
      const isAiden2daysBooking = sessionStorage.getItem('isAiden2daysBooking') === 'true';

      if (isQuality2daysBooking) {
        this.router.navigate(['parkifly', 'quality-xpo-arlanda'], { state: previousSearchData });
      }
      else if (isAiden2daysBooking) {
        this.router.navigate(['parkifly', 'aiden-short-term'], { state: previousSearchData });
      }
      else if (isParkingPermitUser) {
        this.router.navigate(['parkifly', 'p2'], { state: previousSearchData });
      }
      else {
        this.router.navigate(['parkifly', this.site], { state: previousSearchData });
      }
    } else if (config.searchSelect == 'parking-and-transfer') {
      const parkingGroup = this._formService.getForm().get('parkingGroup');
      const search = this._formService.getForm().get('search');
      const flights = this._formService.getForm().get('flights');
      const hotels = this._formService.getForm().get('hotels');
      const pickup = this._formService.getForm().get('pickup');
      const terminal = this._formService.getForm().get('terminal');

      const departureRoute = pickup.controls.departureRoute?.value;
      const arrivalRoute = pickup.controls.arrivalRoute?.value;

      // Serialize routes only if they are objects with date properties, not if they're already strings
      const serializeDepartureRoute = departureRoute ? (
        typeof departureRoute === 'string' ? JSON.parse(departureRoute) :
          {
            ...departureRoute,
            startDate: departureRoute.startDate ? (
              typeof departureRoute.startDate === 'string' ? departureRoute.startDate :
                (departureRoute.startDate.toISOString ? departureRoute.startDate.toISOString() : departureRoute.startDate.format('YYYY-MM-DDTHH:mm:ss'))
            ) : null,
            endDate: departureRoute.endDate ? (
              typeof departureRoute.endDate === 'string' ? departureRoute.endDate :
                (departureRoute.endDate.toISOString ? departureRoute.endDate.toISOString() : departureRoute.endDate.format('YYYY-MM-DDTHH:mm:ss'))
            ) : null
          }
      ) : null;

      const serializeArrivalRoute = arrivalRoute ? (
        typeof arrivalRoute === 'string' ? JSON.parse(arrivalRoute) :
          {
            ...arrivalRoute,
            startDate: arrivalRoute.startDate ? (
              typeof arrivalRoute.startDate === 'string' ? arrivalRoute.startDate :
                (arrivalRoute.startDate.toISOString ? arrivalRoute.startDate.toISOString() : arrivalRoute.startDate.format('YYYY-MM-DDTHH:mm:ss'))
            ) : null,
            endDate: arrivalRoute.endDate ? (
              typeof arrivalRoute.endDate === 'string' ? arrivalRoute.endDate :
                (arrivalRoute.endDate.toISOString ? arrivalRoute.endDate.toISOString() : arrivalRoute.endDate.format('YYYY-MM-DDTHH:mm:ss'))
            ) : null
          }
      ) : null;

      const getValString = (val: any) => {
        if (!val) return null;
        if (val instanceof Date) return this.datepipe.transform(val, 'yyyy-MM-ddTHH:mm:ss');
        if (typeof val === 'string') return val;
        return val;
      };

      let previousSearchData = {
        isDepartureHotel: search.controls.isDepartureHotel?.value,
        isArrivalHotel: search.controls.isArrivalHotel?.value,
        isArrivalByFlight: search.controls.isArrivalByFlight?.value,
        arrivalDate: getValString(hotels.controls.arrivalDate?.value),
        arrivalFlight: flights.controls.arrivalFlight?.value,
        departureFlight: flights.controls.departureFlight?.value,
        departureFlightDate: getValString(parkingGroup.controls.departureDate?.value),
        departureDatetime: getValString(hotels.controls.departureDatetime?.value),
        departureDatetimeForTransfer: getValString(hotels.controls.departureDatetimeForTransfer?.value),
        parkingEndDatetime: getValString(hotels.controls.parkingEndDatetime?.value),
        departurePassengers: pickup.controls.departurePassengers?.value,
        departureTerminal: terminal.controls.departureTerminal?.value,
        arrivalTerminal: terminal.controls.arrivalTerminal?.value,
        departureRoute: serializeDepartureRoute,
        arrivalRoute: serializeArrivalRoute,
        parkingStartDate: getValString(hotels.controls.parkingStartDate?.value),
        discountCode: this._formService.discountCode
      }

      if (this.site?.toLowerCase() == 'aiden') {
        this.router.navigate(['parkifly/aiden-parkandfly'], { state: previousSearchData });
      } else {
        this.router.navigate(['parkifly/quality-xpo-arlanda-parkandfly'], { state: previousSearchData });
      }
    }
  }
}
